import React from 'react';
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/ArrowForward';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import CardMaster from 'components/Product/CardMaster';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import { shopifyCDNFile } from 'lib/shopifyImageSizer';

interface CardGiftSectionProps {
  title?: string;
  description?: string;
  buttonText?: string;
  buttonUrl?: string;
  images?: [string];
}

const defaultImageValue = [
  shopifyCDNFile('home-choiceCard1.jpg'),
  shopifyCDNFile('home-choiceCard2.jpg'),
  shopifyCDNFile('home-choiceCard5.jpg'),
  shopifyCDNFile('home-choiceCard4.jpg'),
  shopifyCDNFile('home-choiceCard3.jpg'),
];

const CardGiftSection: React.FC<CardGiftSectionProps> = ({ title, description, buttonText = 'Learn more', images = defaultImageValue, buttonUrl = '/landing/card-gift-credit/' }) => {
  return (
    <Stack alignItems="center" spacing={2} sx={{ paddingTop: { xs: '40px', md: '80px' }, paddingBottom: { xs: '40px', md: '80px' } }}>
      <Typography variant="h1" sx={{ maxWidth: { md: 400 }, textAlign: 'center', paddingX: 2 }}>
        {title}
      </Typography>
      <Box sx={{ width: '100%', height: { xs: 200, sm: 280, md: 380, lg: 400 }, paddingTop: 6, position: 'relative', overflow: 'hidden' }}>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 25, sm: 35, md: 58, lg: 90 }}
          width={{ xs: 'calc(100% + 20px)', sm: '100%' }}
          left={{ xs: '-10px', sm: '0' }}
          sx={{ position: 'absolute', height: { xs: 110, sm: 165, md: 260, lg: 322 }, '> div': { marginBottom: 0, borderRadius: { xs: '10px', md: '20px' } } }}
        >
          <CardMaster image={shopifyCDNFile(images[0])} size={'auto'} sx={{ maxWidth: { xs: 100, sm: 150, md: 240, lg: 268 }, maxHeight: { xs: 63, sm: 95, md: 151, lg: 169 } }} />
          <CardMaster image={shopifyCDNFile(images[4])} size={'auto'} sx={{ maxWidth: { xs: 100, sm: 150, md: 240, lg: 268 }, maxHeight: { xs: 63, sm: 95, md: 151, lg: 169 } }} />
        </Stack>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={{ xs: 8, sm: 5, md: 16, lg: 27 }}
          width="100%"
          sx={{ position: 'absolute', height: { xs: 108, sm: 160, md: 250, lg: 322 }, '> div': { marginBottom: 0, borderRadius: { xs: '10px', md: '20px' } } }}
        >
          <CardMaster image={shopifyCDNFile(images[1])} size={'auto'} sx={{ maxWidth: { xs: 120, sm: 200, md: 300, lg: 377 } }} />
          <CardMaster image={shopifyCDNFile(images[3])} size={'auto'} sx={{ maxWidth: { xs: 120, sm: 200, md: 300, lg: 377 } }} />
        </Stack>
        <Stack direction="row" justifyContent="center" width="100%" sx={{ position: 'absolute', '> div': { marginBottom: 0, borderRadius: { xs: '10px', md: '20px' } } }}>
          <CardMaster image={shopifyCDNFile(images[2])} size={'auto'} sx={{ maxWidth: { xs: 171, sm: 260, md: 400, lg: 510 } }} />
        </Stack>
      </Box>
      <Typography variant="body1" sx={{ maxWidth: { md: 400 }, textAlign: 'center', paddingX: 3 }}>
        {description}
      </Typography>

      <Box sx={{ paddingTop: { xs: 2 }, marginBottom: { xs: 8, sm: 14 } }}>
        <Button component={RouterLink} to={buttonUrl} size={'large'} color="secondary" variant="outlined" endIcon={<SendIcon />}>
          {buttonText}
        </Button>
      </Box>
    </Stack>
  );
};

export default CardGiftSection;
